// extracted by css-extract-rspack-plugin
export default {"cardContainer":"Fn9iE","icon":"wYPlv","responsive":"glbC6","bigCard":"yd1rB","cardVertical":"iP7KZ","placeholder":"zM7PR","img":"rFxvZ","blink":"JoimV"};